import $i18n from '@/i18n';
import { Icon } from '@b-design/fusion';
import { formatTime } from '@/utils';
import ColorTags from '@/components/ColorTags';
import { getInvitateStatus } from '@/utils/status.tsx';

const status = {
  active: { color: 'var(--superapp-primary-1)', cursor: 'pointer', whiteSpace: 'nowrap' },
  disabled: { color: 'rgba(212,214,225,1)', whiteSpace: 'nowrap' },
};

export const urlEmun = {
  resend: '/rest/intercnn/invitation/resend',
  withdraw: '/rest/intercnn/invitation/revoke',
};

const statusEmun = {
  INVITE: 'Invitation Sent',
  EXPIRE: 'Invitation Expired',
  WITHDRAW: 'Withdrawn',
  USE: 'Invitation Success',
};
const handleFilters = (values) => {
  const filter = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value, value: key });
  }
  return filter;
};
const statusFilters = handleFilters(statusEmun);

export const renderActionItem = ({ icon, content, active }) => {
  return (
    <div style={active ? status.active : status.disabled}>
      <Icon type={icon} size={'xs'} style={{ marginRight: '12px' }} />
      {content}
    </div>
  );
};
export const columns = [
  {
    title: $i18n.get({ id: 'aopf.pages.invitation.columnsInviter', dm: '邀请者' }),
    // dataIndex: 'invitee',
    cell: (value, index, record) => (
      <>
        <div>{record?.invitee}</div>
        <div>{record?.inviteEmail}</div>
      </>
    ),
    // width: 140,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.invitation.columnsSpace', dm: '空间' }),
    // dataIndex: 'space',
    // width: 140,
    cell: (value, index, record) => record?.extInfo?.space?.name,
  },
  {
    title: $i18n.get({
      id: 'aopf.pages.invitation.columnsStatus',
      dm: '状态',
    }),
    dataIndex: 'status',
    width: 160,
    cell: (value) => <ColorTags {...getInvitateStatus(value)} />,
    // filters: statusFilters,
    // filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.approvals.columnsCreatedOn', dm: '创建时间' }),
    dataIndex: 'gmtCreate',
    cell: (value) => formatTime(value),
    width: 160,
  },
];
